module.exports = __webpack_public_path__ + "static/media/los-angeles-we-facilitate.87deb281.jpg";